export const getClassNameByStatus = (status: boolean | null) => {
  if (status === null) {
    return 'warning'
  } else if (status === true) {
    return 'success'
  } else {
    return 'danger'
  }
}

export const categorizeItemsByStatus = (status: boolean | null) => {
  if (status === null) {
    return 'Pending'
  } else if (status === true) {
    return 'Whitelisted'
  } else {
    return 'Blacklisted'
  }
}

export const displayOrNA = (value: unknown, fallback: string = '--') => {
  if (value === null || value === undefined) return fallback
  if (typeof value === 'string' && value.trim() === '') return fallback
  return String(value)
}

/** Lowercase trim for role comparisons (API may send Manager / manager / MANAGER) */
export const normalizeRoleKey = (r?: string) =>
  String(r || '')
    .trim()
    .toLowerCase()

/**
 * Get dashboard path based on user role
 */
export const getDashboardPath = (role?: any, userType?: any): string => {
  const roleSlug = typeof role === 'object' ? role?.slug : role;
  const userTypeSlug = typeof userType === 'object' ? userType?.slug : userType;
  const r = normalizeRoleKey(roleSlug) || normalizeRoleKey(userTypeSlug);
  
  if (r === 'blog' || r === 'blog_admin') {
    return '/blog-access'
  }
  return '/dashboard'
}

/** Manager role (API may send role or user_type with different casing) */
export const isManagerRole = (role?: string, userType?: string): boolean => {
  const r = normalizeRoleKey(role)
  const u = normalizeRoleKey(userType)
  return r === 'manager' || u === 'manager'
}

/** Spectator or Developer — share spectator dashboard URL */
export const isSpectatorOrDeveloperRole = (role?: string, userType?: string): boolean => {
  const r = normalizeRoleKey(role)
  const u = normalizeRoleKey(userType)
  return (
    r === 'spectator' ||
    r === 'developer' ||
    u === 'spectator' ||
    u === 'developer'
  )
}

/**
 * Get API endpoint based on user role
 * @param role - The role from auth state
 * @param baseEndpoint - Base endpoint (e.g., 'dashboard', 'profile')
 * @returns Role-based API endpoint
 */
export const getRoleBasedApiEndpoint = (
  role?: string,
  baseEndpoint: string = 'dashboard'
): string => {
  return `auth/useradmin/${baseEndpoint}/`
}
